import { useGiftCardData } from '@/modules/perseo-billing/hooks';
import { formatPrice } from '@/modules/perseo-billing/hooks/utils';
import { Typography } from '@/modules/perseo-billing/ui/react/src';

const LABEL_TOTAL_GIFT_CARD = 'Total a pagar con Gift card:';
const LABEL_APPLIED_GIFT_CARD = 'Gift Card aplicada:';

export const GiftCardPaymentLabel = () => {
  const { getGiftCardAmount, canGiftCardPayTotalAmount } = useGiftCardData();

  const canPayTotalAmount = canGiftCardPayTotalAmount();
  const totalGiftCard = getGiftCardAmount();
  const totalPrice = formatPrice(totalGiftCard);

  return (
    <div className="co-flex co-w-full co-gap-6" tabIndex={0}>
      <Typography>
        {canPayTotalAmount ? LABEL_TOTAL_GIFT_CARD : LABEL_APPLIED_GIFT_CARD}
      </Typography>
      <Typography weight="semibold" color="black">
        {canPayTotalAmount ? '' : '-'}
        {totalPrice}
      </Typography>
    </div>
  );
};
